export class ValidarContasReceberImportacaoRequest {
    arquivoBase64!: string;
}
